// CWE-922 / CSRF doble-submit: la cookie mc_csrf NO es HttpOnly, así que el JS
// la lee y la reenvía como header X-CSRF-Token en las mutaciones. El backend
// compara header vs cookie. (mc_token sí es HttpOnly → nunca visible acá.)
export function getCsrfToken(): string | null {
	const m = document.cookie.match(/(?:^|;\s*)mc_csrf=([^;]+)/);
	return m ? decodeURIComponent(m[1]) : null;
}
